export default __webpack_public_path__ + "static/media/chat-icon.6c77b4c0.svg";